import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const createBooking = (data) => api.post("/bookings", data).then(r => r.data);
export const getTakenSlots = () => api.get("/bookings/taken").then(r => r.data);
export const getBlockedDates = () => api.get("/blocked-dates").then(r => r.data.dates || []);
export const adminLogin = (password) => api.post("/admin/login", { password }).then(r => r.data);
export const adminListBookings = (token) =>
  api.get("/admin/bookings", { headers: { "X-Admin-Token": token } }).then(r => r.data);
export const adminDeleteBooking = (id, token) =>
  api.delete(`/admin/bookings/${id}`, { headers: { "X-Admin-Token": token } }).then(r => r.data);
export const adminSaveContent = (data, token) =>
  api.put("/admin/content", { data }, { headers: { "X-Admin-Token": token } }).then(r => r.data);
export const adminSaveBlockedDates = (dates, token) =>
  api.put("/admin/blocked-dates", { dates }, { headers: { "X-Admin-Token": token } }).then(r => r.data);
